import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  selector: 'email-event-reminder-scheduled-template',
  styleUrls: ['../../global-styles.less', './event-reminder-scheduled.component.less'],
  templateUrl: './event-reminder-scheduled.component.html',
  imports: [
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailMarginComponent,
    EmailTextComponent,
    EmailButtonComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class EventReminderScheduledTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<EventReminderScheduledTemplateData>;
}

export type EventReminderScheduledTemplateData = {
  p1: string;
  event_full: string;
  button_link: string;
  button_text: string;
  timezone: string;
  interviewers: string;
  interviewers_label: string;
};

export const EventReminderScheduledTemplateMocks: EventReminderScheduledTemplateData[] = [
  {
    p1: 'Upcoming event with CompanyName',
    event_full: 'On-site interview 29 January 2024 1:02 PM — 1:32 PM (GMT+01:00) Europe/Warsaw',
    button_text: 'View event',
    button_link: 'http://company_subdomain.recruitee.internal:3003/v/events/event_token',
    timezone: '(GMT+01:00) Europe/Warsaw',
    interviewers: 'Maciej van der Sawi Langetermjin Nakomen',
    interviewers_label: 'Interviewers',
  },
];
